export { ArticleProductTypes as default } from "./article-product-types";
